/**
 * 本地开发IP及端口
 */
// -----------------------------后台业务管理-------------------------------
// let httpBaseURL = 'http://192.168.8.200:8081' // 郑仕豪本地
// let httpBaseURL = 'http://192.168.8.30:8081' // 泽龙本地
// let httpBaseURL = 'http://192.168.8.23:8081' // 荣霖本地
// let httpBaseURL = 'http://192.168.8.44:8081' // 资源本地
// -----------------------------后台任务调度管理-------------------------------
// let httpTaskURL = 'http://192.168.8.30:8083' // 荣霖本地
/**
 * 测试服务器IP及端口
 */
// -----------------------------后台业务管理-------------------------------
// let httpBaseURL = 'http://121.199.78.45:8084' // 测试1
// -----------------------------后台任务调度管理-------------------------------
// let httpTaskURL = 'http://121.199.78.45:8083' // 测试

/**
 * 预生产服务器IP及端口
 */
// -----------------------------后台业务管理-------------------------------
// let httpBaseURL = 'http://121.199.78.45:8121' // 预生产
// -----------------------------后台任务调度管理-------------------------------
// let httpTaskURL = 'http://121.199.78.45:8122' // 预生产

/**
 * 正式服务器IP及端口
 */
// -----------------------------后台业务管理-------------------------------
// let httpBaseURL = 'http://bxyc.fjwing.cn:83' // 正式
// // -----------------------------后台任务调度管理-------------------------------
// let httpTaskURL = 'http://bxyc.fjwing.cn:85' // 正式

// let httpBaseURL = 'http://127.0.0.1:8081'
// let httpTaskURL = 'http://bxyc.fjwing.cn:85'
/**
 * cs
 */
// -----------------------------后台业务管理-------------------------------
// 禁止提交代码为本地
// let httpBaseURL = 'http://127.0.0.1:8081' // 正式
// let httpBaseURL = 'http://47.110.129.181:8081' // 正式
// let httpBaseURL = 'http://47.110.129.181:8971' // 正式
// // // -----------------------------后台任务调度管理-------------------------------
// let httpTaskURL = 'http://127.0.0.1:8083' // 正式

/**
 * 正式服务器IP及端口
 */
// -----------------------------后台业务管理-------------------------------
let httpBaseURL = 'http://bxyc.fjwing.cn:83' // 正式
// -----------------------------后台任务调度管理-------------------------------
let httpTaskURL = 'http://bxyc.fjwing.cn:85' // 正式

/**
 *其他业务服务uri
 */
let uploadPath = '/api/file/upload' // 上传文件接口
let editorUpload = '/api/UtilController/editorUpload' // 富文本上传图片接口
let collectActivityCode = 'COLLECT_ACTIVITY' // 收集活动code
let distributeCardCode = 'DISTRIBUTE_CARD_ACTIVITY' // 发卡活动code
let redeemActivityCode = 'REDEEM_ACTIVITY' // 兑换活动code
export default {
  httpBaseURL,
  httpTaskURL,
  uploadPath,
  editorUpload,
  collectActivityCode,
  distributeCardCode,
  redeemActivityCode
}



// WEBPACK FOOTER //
// ./src/utils/global.js